import {
  useSelector as useReduxSelector,
  useDispatch,
  TypedUseSelectorHook,
} from "react-redux";
import { RootState } from "configs/store/types";

const useSelector: TypedUseSelectorHook<RootState> = useReduxSelector;

export { useDispatch, useSelector };
